module.exports = __webpack_public_path__ + "static/media/ki.1e425fd5.svg";